import React from 'react';
import './LaCarte.css';

/* ======================== MENU DATA ======================== */

interface MenuItem {
  name: string;
  description?: string;
  price: string;
  price2?: string;
  priceLabel?: string;
  priceLabel2?: string;
}

interface MenuCategory {
  title: string;
  note?: string;
  intro?: string;
  items: MenuItem[];
}

const menuData: MenuCategory[] = [
  {
    title: "À l'apéro pour partager",
    items: [
      { name: 'Pan Con Tomate', description: 'Toast à la tomate', price: '4,50€', priceLabel: 'Petite as.' },
      { name: 'Jamon Ibérico Artisanal 100% Bellota', description: 'Jambon Ibérique Artisanal', price: '12€', price2: '21€', priceLabel: 'Petite as.', priceLabel2: 'Grande as.' },
      { name: 'Chorizo Ibérico de Bellota', description: 'Chorizo Ibérique', price: '9,50€', price2: '17€', priceLabel: 'Petite as.', priceLabel2: 'Grande as.' },
      { name: 'Cecina de León con tomates confitados y queso', description: 'Cecina de León avec tomates confites et copeaux de manchego, basilic', price: '10€', price2: '18,50€', priceLabel: 'Petite as.', priceLabel2: 'Grande as.' },
      { name: 'Lomito de Bellota Artisanal 100% Ibérico', description: 'Filet mignon Ibérique', price: '9,50€', price2: '18,50€', priceLabel: 'Petite as.', priceLabel2: 'Grande as.' },
      { name: 'Puntillitas', description: 'Mini calamars', price: '4,50€', price2: '8,50€', priceLabel: 'Petite as.', priceLabel2: 'Grande as.' },
      { name: 'Pimientos del Padrón', description: 'Poivrons du Padrón', price: '4,50€', price2: '8,50€', priceLabel: 'Petite as.', priceLabel2: 'Grande as.' },
      { name: 'Plato Mixto', description: 'Assiette de charcuteries Ibériques et fromage (coupe minute)', price: '18€' },
      { name: 'Manchego Seco', description: 'Assiette de fromage', price: '8€', priceLabel: 'Petite as.' },
      { name: 'Plato Mixto de Quesos', description: 'Assiette en assortiment de fromages', price: '12€' },
      { name: 'Navajas a la Plancha', description: "Couteaux de mer, frais, juste saisis à la plancha, parfumés à l'huile d'olive, ail et persil", price: '11€' },
      { name: 'Gambas a la Plancha', description: "Gambas sauvages d'Argentine, juste sautées dans un filet d'huile d'olive ail et persil", price: '11€' },
      { name: 'Sepia a la Plancha', description: "Émincé de seiche marinée à l'huile d'olive, ail et persil, juste snackée à la plancha", price: '11,50€' },
      { name: 'Anchoas del Cantábrico', description: 'Anchois de Cantabrie pêchés sur de petits bateaux, préparés et mis en boîte à la main. Chair très fine et sans arêtes "le caviar Espagnol"', price: '12€' },
      { name: 'Pulpo a la Gallega', description: "Poulpe de Méditerranée au paprika fumé et à l'huile d'olive extra vierge, sur son lit de pommes de terre", price: '14€' },
      { name: 'Chanquetes, salsa Mojo Picón', description: "Mini crevettes sauce Mojo Picón (huile d'olive, piments d'oiseaux, ail, cumin)", price: '11,50€' },
    ],
  },
  {
    title: 'Nos Tapas',
    items: [
      { name: 'Bacalao relleno de bechamel de setas', description: 'Morue farcie à la béchamel de champignons, huile de persil et jus de piquillo', price: '4,50€' },
      { name: 'Calabacín relleno de bechamel de puerros', description: 'Courgettes farcies à la béchamel de poireaux, jambon et vinaigrette aux tomates', price: '4,50€' },
      { name: 'Alcachofas en salsa Mojo Verde', description: "Artichauts en sauce Mojo Verde (huile d'olive, persil, cumin, vinaigre de vin blanc)", price: '4,50€' },
      { name: 'Berenjenas rebozadas con miel de caña', description: 'Aubergines panées et miel de canne à sucre', price: '4,50€' },
      { name: 'Bikini de mozzarella', description: 'Toast chaud de mozzarella et paletilla Ibérique, huile de truffe blanche', price: '4,50€' },
      { name: 'Croquetas de champiñones y queso de cabra', description: 'Croquettes de champignons et fromage de chèvre (min. 2, la pièce en supp. 2,25€)', price: '4,50€' },
      { name: "Chorizo a l'Asturiana", description: "Chorizo à l'asturienne", price: '4,50€' },
      { name: 'Croquetas de jamón serrano "Las Tapas"', description: 'Croquettes de jambon serrano (min. 2, la pièce en supp. 2,25€)', price: '4,50€' },
      { name: 'Flamenquines', description: 'Rouleaux Cordouans — Escalope de dinde farcie au jambon serrano, fromage et olives vertes', price: '4,50€' },
      { name: 'Habas con jamón', description: 'Fèves au jambon à la crème', price: '4,50€' },
      { name: 'Láminas de calamares empanados', description: 'Lamelles de calamars panés', price: '4,50€' },
      { name: 'Morcilla a la Plancha', description: 'Boudin noir de Burgos à la plancha', price: '4,50€' },
      { name: 'Patatas Bravas', description: 'Pommes de terre à la sauce tomate piquante', price: '4,50€' },
      { name: 'Patatas Alioli', description: "Pommes de terre à l'aïoli", price: '4,50€' },
      { name: 'Pimientos rellenos de bacalao con miel de caña', description: 'Poivrons farcis à la morue avec un filet de miel de canne à sucre', price: '4,50€' },
      { name: 'Pinchitos morunos de pollo', description: 'Brochettes de poulet marinées à la maure', price: '4,50€' },
      { name: 'Ración de mejillones rellenos', description: 'Portion de moules farcies et jambon', price: '4,50€' },
      { name: 'Salteado de setas con jabugo', description: 'Sauté de pleurotes avec épaule Ibérique', price: '4,50€' },
      { name: 'Sofrito', description: 'Mélange de poivrons et tomates', price: '4,50€' },
      { name: 'Tortilla', description: 'Omelette Espagnole', price: '4,50€' },
      { name: 'Bacalao en Tempura, salsa Mojo Picón', description: "Morue en Tempura sauce Mojo Picón (huile d'olive, paprika, piquillo, ail, Xérès)", price: '4,50€' },
      { name: 'Pan Rico', description: 'Sandwich façon pain perdu avec jambon blanc et crabe', price: '4,50€' },
      { name: 'Pinchos fríos de puerros, salmón', description: "Toast froid de poireau, saumon, œufs de truite (min. 2, la pièce en supp. 2,25€)", price: '4,50€' },
      { name: 'Pincho de ensalada agazpachada con jamón', description: 'Toast de salade de gaspacho au jambon', price: '4,50€' },
      { name: 'Pinchos del Chef', description: 'Toast de salade Iceberg, mayonnaise, paletilla Ibérique (min. 2, la pièce en supp. 2,25€)', price: '4,50€' },
    ],
  },
  {
    title: 'Nos Suggestions',
    items: [
      { name: 'Ensaladilla Rusa', description: 'La traditionnelle salade Espagnole de pommes de terre, olives, œufs et thon liés à la mayonnaise', price: '4,90€' },
      { name: 'Pinchos de queso de cabra y anchoas', description: 'Fromage de chèvre rôti, anchois, tomates confites, marmelade de poivrons verts (min. 2, la pièce en supp. 2,75€)', price: '5,50€' },
      { name: 'Pinchos de serrano y salmón', description: 'Brochette de Serrano et saumon, œuf et crevettes de Huelva (min. 2, la pièce en supp. 2,90€)', price: '5,80€' },
      { name: 'Gambas al pil-pil', description: "Petites crevettes roses épluchées à la main, huile d'olive, ail et piment d'oiseau. Servi chaud.", price: '6,50€' },
      { name: 'Zamburiñas, mantequilla de ajo negro', description: "Saint-Jacques au beurre d'ail noir", price: '12€' },
      { name: 'Brocheta de gambas de Huelva', description: "Brochette de crevettes de Huelva et œuf glacé à l'aïoli", price: '5,20€', price2: '10,40€', priceLabel: '1 pièce', priceLabel2: '2 pièces' },
      { name: 'Verduritas a la plancha', description: 'Légumes à la plancha', price: '4,50€', price2: '8,50€', priceLabel: 'Petite', priceLabel2: 'Grande' },
      { name: 'Croquetas de Pollo asado', description: 'Croquettes de Poulet fermier rôti "label rouge"', price: '8,20€' },
      { name: 'Croquetas de gambas', description: 'Croquettes de gambas sauvages', price: '8,90€' },
      { name: 'Lomos de sardinas ahumadas', description: 'Sardines fumées sur lit de pommes de terre', price: '10€' },
      { name: 'Carpaccio de bacalao con cítricos', description: 'Carpaccio de morue aux agrumes', price: '12,50€' },
      { name: 'Secreto Ibérico Bellota Artisanal', description: "Pièce de viande d'exception de porc Ibérique snackée à la plancha et assaisonnée de fleur de sel", price: '14€' },
      { name: 'Croquetas de cabra con manzana y miel', description: 'Croquettes de chèvre, pommes et miel', price: '8,30€' },
      { name: 'Chistorra con sofrito y huevo de codorniz', description: 'Saucisse rouge (mélange porc et bœuf, piment doux, paprika), sofrito et œuf de caille', price: '7€' },
    ],
  },
  {
    title: 'Nos Paellas',
    note: 'Temps de préparation pour les paellas : 35 minutes',
    items: [
      { name: 'Paella con chorizo ibérico', description: 'Paella au chorizo ibérique (min 2 pers.)', price: '19€/Pers' },
      { name: 'Paella de Mariscos', description: 'Paella aux fruits de mer et poulet (min 2 pers.)', price: '21€/Pers' },
      { name: 'Paella de Fidéo', description: 'Paella fruits de mer et poulet avec des pâtes (min 2 pers.)', price: '20€/Pers' },
      { name: 'Paella de Carabineros', description: 'Paella de gambas rouges (min 2 pers.)', price: '31€/Pers' },
    ],
  },
  {
    title: 'Nos Plats',
    items: [
      { name: 'Ensalada del día pescado', description: 'Salade du jour poisson (demandez au serveur)', price: '15€' },
      { name: 'Ensalada del día de carne', description: 'Salade du jour viande (demandez au serveur)', price: '15€' },
      { name: 'Ensaladilla Rusa', description: 'La traditionnelle salade Espagnole de pommes de terre, olives, œufs et thon liés à la mayonnaise', price: '12,50€' },
      { name: 'Costillas de cerdo ibérico "Beher"', description: 'Côtes de porc Ibérique (220 gr) 18 min de cuisson. Garnitures au choix : sofrito, pleurotes, patatas, fèves', price: '23€' },
      { name: 'Carpaccio de bacalao con cítricos', description: 'Carpaccio de morue aux agrumes', price: '16,50€' },
      { name: 'Hamburguesa de cerdo Ibérico', description: 'Hamburger de porc Ibérique, sobrasada, confit de piquillo, fromage de brebis', price: '19€' },
      { name: 'Carpaccio de buey', description: "Carpaccio de bœuf, huile de chorizo, piquillo, olives vertes, manchego, patatas", price: '18,50€' },
    ],
  },
  {
    title: 'Nos Desserts Maison',
    items: [
      { name: 'Bollitos de Turrón', description: 'Petits choux au turrón', price: '6,50€' },
      { name: 'Merengue de crema de limón', description: 'Meringue, crème citronnée', price: '6,50€' },
      { name: 'Crema Catalana', description: "Crème pâtissière tiède brûlée à l'orange", price: '7,50€' },
      { name: 'Pastel de Turrón', description: 'Fondant au turrón servi tiède avec coulis de fruits rouges', price: '7,50€' },
      { name: 'Pastel de Chocolate', description: 'Fondant au chocolat, cœur chocolat blanc, servi tiède avec crème anglaise', price: '7,50€' },
      { name: 'Tarta de la casa', description: 'Tarte maison du jour', price: '7,50€' },
      { name: 'Tarta de Queso', description: 'Tarte au fromage et coulis de framboise', price: '7,50€' },
      { name: 'Tarta de Santiago', description: 'Gâteau aux amandes', price: '7,50€' },
      { name: 'Leche Frita', description: 'Lait frit monté en flan, zeste de citron, cannelle', price: '7,50€' },
      { name: 'Plato Mixto Quesos', description: 'Assiette en assortiment de fromages', price: '12€' },
      { name: 'Café gourmand', price: '7,50€' },
      { name: 'Thé gourmand', price: '7,50€' },
    ],
  },
  {
    title: 'Nos Glaces',
    intro: "Ma très bonne glace, c'est avant tout le choix d'une glace artisanale, 100% gourmande grâce à des ingrédients nobles sélectionnés pour leurs saveurs et leurs origines.",
    items: [
      { name: 'Turrón helado de la casa', description: 'Turrón glacé maison', price: '8€' },
      { name: 'Parfums de glaces au choix', description: 'Café do Brazil au lait entier frais, chocolat noir, chocolat blanc, pâte à tartiner, coco, passion, mangue, dulce de leche, vanille, mandarine d\'Espagne, fraise, pomme verte', price: '2,20€ · 4,40€ · 6,60€', priceLabel: '1 / 2 / 3 boules' },
      { name: 'Supplément chantilly', price: '0,50€' },
    ],
  },
];

/* ======================== COMPONENTS ======================== */

function MenuItemRow({ item }: { item: MenuItem }) {
  return (
    <div>
      <div className="menu-item">
        <span className="menu-item__name">{item.name}</span>
        <span className="menu-item__separator" />
        {item.price2 ? (
          <div className="menu-item__prices">
            <span className="menu-item__price">
              {item.priceLabel && <span className="menu-item__price-label">{item.priceLabel}</span>}
              {item.price}
            </span>
            <span className="menu-item__price">
              {item.priceLabel2 && <span className="menu-item__price-label">{item.priceLabel2}</span>}
              {item.price2}
            </span>
          </div>
        ) : (
          <span className="menu-item__price">
            {item.priceLabel && <span className="menu-item__price-label">{item.priceLabel}</span>}
            {item.price}
          </span>
        )}
      </div>
      {item.description && (
        <p className="menu-item__description">{item.description}</p>
      )}
    </div>
  );
}

function LaCarte() {
  return (
    <div className="carte-page">
      {/* Hero */}
      <div className="carte-hero">
        <div className="carte-hero-layout">
          <div className="carte-hero-left">
            <h1>La Carte</h1>
            <div className="carte-decor-row">
              <img src="/assets/Las-Tapas-35.svg" alt="" />
              <img src="/assets/Las-Tapas-15.svg" alt="" />
            </div>
          </div>
          <div className="carte-hero-right">
            <img src="/assets/Las-Tapas-17.svg" alt="" />
            <img src="/assets/Las-Tapas-26.svg" alt="" />
            <img src="/assets/Las-Tapas-14.svg" alt="" />
            <img src="/assets/Las-Tapas-19.svg" alt="" />
          </div>
        </div>
      </div>

      {/* Menu */}
      <div className="menu-container">
        {menuData.map((category, catIndex) => (
          <div className="menu-category" key={catIndex}>
            <h3 className="menu-category__title">{category.title}</h3>
            {category.note && <p className="menu-category__note">{category.note}</p>}
            {category.intro && <p className="menu-category__intro">{category.intro}</p>}
            {category.items.map((item, itemIndex) => (
              <MenuItemRow key={itemIndex} item={item} />
            ))}

            {/* Decorative separator between categories */}
            {catIndex < menuData.length - 1 && (
              <div className="carte-section-divider">
                <img src="/assets/Las-Tapas-25.svg" alt="" />
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default LaCarte;
